import * as React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export interface OptionBase {
  label: string;
  value: any;
}

export interface BulkUploadAutocompleteSelectOptionProps<T extends OptionBase> {
  options: T[];
  label: string;
  className?: string;
  onChange: (value: T | null) => void;
  value: T | null;
}

export const BulkUploadAutocompleteSelect = <T extends OptionBase>({
  options,
  label,
  className,
  onChange,
  value,
}: BulkUploadAutocompleteSelectOptionProps<T>) => {
  const filter = createFilterOptions<T>();

  return (
    <Autocomplete
      className={className}
      value={value}
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
          return;
        }
        onChange(newValue);
      }}
      filterOptions={(options, params) => filter(options, params)}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      options={options}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.label)}
      renderOption={(props, option) => (
        <li key={option.value} {...props}>
          {option.label}
        </li>
      )}
      freeSolo
      renderInput={(params) => <TextField {...params} variant="standard" label={label} />}
    />
  );
};
